var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8F2",
    d: "M44.127 26.145V0h30.28v20.622c0 11.153-1.673 19.258-5.016 24.243C65.007 51.537 58.022 56.558 48.51 60l-6.91-8.75c5.758-1.901 9.994-4.77 12.706-8.572s4.235-9.325 4.532-16.57H44.09zM2.66 26.145V0h30.28v20.622c0 11.153-1.672 19.258-5.016 24.243C23.54 51.537 16.555 56.558 7.044 60l-6.91-8.75c5.758-1.901 9.994-4.77 12.706-8.572q4.068-5.703 4.57-16.57H2.66z"
  })));
};
export default SvgQuotes;